import NiceModal, { type NiceModalHandler } from "@ebay/nice-modal-react";
import type { ModalOverlayProps } from "react-aria-components";

/**
 * Convert a {@link NiceModal} into props for a {@link DialogOverlay} component.
 * @example <DialogOverlay {...niceOverlayProps(modal)}>
 */
export function niceOverlayProps(modal: NiceModalHandler) {
    return {
        isOpen: modal.visible,
        onOpenChange: (b) => void (b ? modal.show() : modal.remove()),
    } satisfies Partial<ModalOverlayProps>;
}
